import type { CSSProperties } from 'react';

const MAX_WIDTH = 800;
export const availableMiniModalWidth = 'calc(100vw - 100px)';

/** Mini-modal open dimensions at the resize maximum, clamped to the viewport. */
export const getMiniModalMaxSizeStyle = (
	availableHeight: string,
): Required<Pick<CSSProperties, 'width' | 'height'>> => ({
	width: `min(${MAX_WIDTH}px, ${availableMiniModalWidth})`,
	height: availableHeight,
});
